import { Dispatch, FC, SetStateAction } from 'react';
import { useTranslation } from 'react-i18next';

import { Box, Typography } from '@mui/material';
import clsx from 'clsx';

import { ReactComponent as CheckedIcon } from 'assets/icons/CheckedIcon.svg';

import { useBusinessPlanTypeAvailability } from 'hooks/useBusinessPlanTypeAvailability';

import { IBusinessPlanButtonOptionLabels, IBusinessPlanType } from 'interfaces/businessPlan';

import styles from './SelectTemplateMobileButton.module.scss';

interface IProps {
  template: IBusinessPlanType;
  label: IBusinessPlanButtonOptionLabels;
  icon: React.ReactNode;
  color: string;
  borderColor: string;
  backgroundColor: string;
  isSelected: boolean;
  setSelectedTemplate: Dispatch<SetStateAction<IBusinessPlanType>>;
}

export const SelectTemplateMobileButton: FC<IProps> = ({
  template,
  label,
  icon,
  color,
  borderColor,
  backgroundColor,
  setSelectedTemplate,
  isSelected,
}) => {
  const { limit, isAvailable } = useBusinessPlanTypeAvailability(template);
  const { t } = useTranslation();

  const cssVariables = {
    '--plan-color': color,
    '--plan-background': backgroundColor,
    '--plan-borderColor': borderColor,
  } as React.CSSProperties;

  return (
    <Box
      style={cssVariables}
      className={clsx(styles.wrapper, { [styles.disabled]: limit === 0 && !isAvailable })}
      onClick={() => setSelectedTemplate(template)}
    >
      <Box className={styles.contentWrapper}>
        <Box className={styles.icon}>{icon}</Box>
        <Box className={styles.label}>{label}</Box>
        <Typography className={styles.planAvailabilityCount} variant="body2">
          ({limit} {t('left')})
        </Typography>
      </Box>
      {isSelected && <CheckedIcon />}
    </Box>
  );
};
